export default {
  buttons: {
    back: 'Wstecz',
  },
};
